import { Injectable } from '@angular/core';
import { AbstractContentfulStateService, IContentfulColumnType } from '@y42/contentful';
import { ColumnTypeEnum } from '@y42/json-schema';
import { Entry } from 'contentful';
import { ColumnDataType } from './column-data-type.model';

@Injectable({ providedIn: 'root' })
export class ColumnTypesStateService extends AbstractContentfulStateService<IContentfulColumnType, ColumnDataType> {
  constructor() {
    super(
      'originalColumnType',
      'fields.displayName',
      1000,
      (item: Entry<IContentfulColumnType>) =>
        ({
          name: item.fields.displayName,
          icon: item.fields.logo?.fields.file.url,
          color: item.fields.color,
          columnType: item.fields.type,
        } as ColumnDataType),
    );
  }

  getTypeById(columnType: ColumnTypeEnum): ColumnDataType {
    return this.state.entityState!.find((type) => type.columnType === columnType)!;
  }

  getPropertyByType(columnType: ColumnTypeEnum, property: keyof ColumnDataType): string {
    const columnTypeData = this.state.entityState!.find((type) => type.columnType === columnType)!;
    return columnTypeData[property]!;
  }
}
